// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"446d64a8","488":"b5169e0e"}[chunkId] + ".chunk.js";
};